module.exports = __webpack_public_path__ + "static/ss17.1b75eedc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/studysmart/ss/ss17.jpg
// module id = 1194
// module chunks = 81679748166845